<!-- <ng-container *ngIf="isLoading; else pageContent">
  <div class="loading-screen">
    <div
      class="ai-image-wrapper d-flex flex-column justify-content-center align-items-center">
      <img src="assets/images/ai.gif" alt="AI Background" class="ai-bg-gif" />
      <img src="assets/images/ai03.png" alt="AI Bot" class="ai-overlay-bot" />
    </div>

    <h3 class="loading-title">“AI” Is Analyzing Your Course</h3>
    <p class="loading-subtitle">
      "Just a moment — AI is picking the most relevant topics for your
      curriculum."
    </p>
  </div>
</ng-container> we are not using this loading messge for now but later we can used this -->
<!-- <ng-template #pageContent> -->

  <form [formGroup]="generateSyllabusForm" enctype="multipart/form-data">
    <mat-icon (click)="goBackToClassroomDetailPage()" class="create-account">arrow_back</mat-icon>
    <div class="ai-container">
      <div class="ai-header">
        <img src="assets/images/ai02.svg" alt="AI Bot" class="ai-avatar" />
        <h2 class="title">AI Course Creator</h2>
        <p class="subtitle">
          "Build complete courses faster — let AI turn your ideas into a full
          syllabus."
        </p>
      </div>
      <div class="input-wrapper">
        <div class="input-box">
          <textarea
            class="input"
            rows="2"
            formControlName="description"
            placeholder="Enter prompt to create your course using AI">
          </textarea>
          <div class="attached-resources" *ngIf="links.length > 0">
            <div class="chip" *ngFor="let link of links; let i = index">
              <i class="bi bi-link"></i>
              <a
                [href]="link"
                target="_blank"
                [title]="link"
                class="truncate-url">{{ link }}</a>
              <button type="button" class="delete-btn" (click)="removeUrl(i)">
                <i class="bi bi-trash-fill text-danger"></i>
              </button>
            </div>
          </div>

          <div class="attached-resources" *ngIf="uploadedImages.length > 0">
            <div class="chip" *ngFor="let item of uploadedImages">
              <i class="bi bi-file-earmark-text"></i>
              <span>{{ item.file.name }}</span>
              <button
                type="button"
                class="delete-btn"
                (click)="removeImage(item)">
                <i class="bi bi-trash-fill text-danger"></i>
              </button>
            </div>
          </div>

          <div class="actions">
              <img src="assets/images/course1.png" 
              class="bi bi-globe"
              [ngClass]="{'active-icon': generateSyllabusForm.get('use_research_tools')?.value}"
              (click)="toggleResearchTool()"
              matTooltip="Use AI Tool">

			   <label class="icon-btn" (click)="openAddLinkDialogBox()">
              <img src="assets/images/course3.png" alt="urls"
			  matTooltip="Use urls">
            </label> 

            <label class="icon-btn">
              <img src="assets/images/course2.png" alt="file"
			  matTooltip="Upload File">
              <input
                type="file"
                accept=".pdf,.docx,.txt"
                (change)="onFileSelected($event)"
                hidden/>
            </label>

            <button class="create-btn" (click)="generateCourse()">
              Create <i class="bi bi-stars"></i>
            </button>
          </div>
		  <ng-container *ngIf="!isTenantMember">
		  <div class="upgrade-ui mt-2 p-2 justify-content-center">
		  You're on the Free Plan, create up to 2 AI courses. Upgrade anytime to unlock unlimited course creation and more features.
		  <span><a [routerLink]="['/teacher-dashboard/upgrade-plan']">Upgrade Now</a></span>
		</div></ng-container>
        </div>
      </div>
      <div class="suggestions">
        <span class="suggestion-label">
          <img src="assets/images/aisugg.svg" alt="AI Suggestions" /> Prompt
          Instructions</span>
        <div class="suggestion-tags">
          <div class="tag">
            <i class="bi bi-mortarboard"></i> Add grade level specification
          </div>
          <div class="tag">
            <i class="bi bi-journal-richtext"></i> Include learning objectives
          </div>
          <div class="tag">
            <i class="bi bi-clock"></i> Specify course duration
          </div>
          <div class="tag">
            <i class="bi bi-clipboard-check"></i> Add assessment methods
          </div>
        </div>
      </div>
    </div>
  </form>
<!-- </ng-template> -->